'use client';

import React from 'react';

import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import useGlobalState from '@hooks/useGlobalState';
import { EscrowPageProps } from '@models/women';
import DesktopHeaderLayoutContainer from '../DesktopHeaderLayoutContainer';

const pageName = '서비스 가입사실 확인';
const pageClassName = 'service-confirmation-page';

function ServiceConfirmationPage() {
  const { initialData } = useGlobalState<EscrowPageProps>();
  return (
    <DesktopHeaderLayoutContainer
      pageTitle={pageName}
      className={pageClassName}
      megaMenu={initialData?.megaMenu}
      gnbInfo={initialData?.gnbInfo || []}
      searchInitInfo={initialData?.searchInitInfo}
    >
      <div>
        <div className="content">
          <Img
            src="https://static.wconcept.co.kr/web/Images/common/purchaseSafety_conf.jpg"
            alt="서비스 가입사실 확인"
          />
        </div>
        <style>{`
    .content {
      text-align: center;
    }
    .content img {
      position: static !important;
      max-width: 1000px;
    } 
  `}</style>
      </div>
    </DesktopHeaderLayoutContainer>
  );
}

export default ServiceConfirmationPage;
